import { domAnimation, LazyMotion, m } from 'framer-motion'

import { CheckIcon } from './CheckIcon'
import type { StepStatusType } from './utils'
import { badgeVariants, StepStatus } from './utils'

export function StepBadge({ status, number }: { status: StepStatusType; number: number }) {
	if (status === StepStatus.COMPLETE) {
		return (
			<LazyMotion features={domAnimation}>
				<m.div
					animate={status}
					initial={false}
					variants={badgeVariants}
					className="text-medium lg:text-large flex size-8 shrink-0 items-center justify-center rounded-full font-semibold lg:size-9"
					transition={{ duration: 0.25 }}
					data-status={status}
				>
					<CheckIcon className="size-5 text-black lg:size-6" />
				</m.div>
			</LazyMotion>
		)
	}
	const borderClass =
		status === StepStatus.ACTIVE
			? 'border-medium border-warning-500 text-warning-500'
			: 'border-medium border-default-300 text-default-500'
	return (
		<div
			className={`flex size-8 items-center justify-center rounded-full lg:size-9 ${borderClass} text-medium lg:text-large shrink-0 font-semibold`}
		>
			<span>{number}</span>
		</div>
	)
}
